import ErrorMessage from '../../Elements/ErrorMessage';

// CD-5466: generation is asynchronous — the backend queues the request and returns immediately; the result
// (created invoice ids, warnings or errors) arrives later as an in-app popup notification, even if the user
// has left this page. This handler only acknowledges the queuing.
export function handleIobQueuedResponse(response) {
  if (!response) return;

  if (response.errors && response.errors.length > 0) {
    ErrorMessage.SetErrorMessage(response.errors.join('\n'));
    return;
  }

  ErrorMessage.SetNotification(
    response.queuedMessage || 'IOB generation has been queued. A notification will pop up when it finishes.'
  );
}

export function handleReverseIobResponse(response) {
  if (!response) return;

  if (response.errors && response.errors.length > 0) {
    ErrorMessage.SetErrorMessage(response.errors.join('\n'));
    return;
  }

  const parts = [];
  if (response.createdIobInvoiceId) {
    parts.push(`Created Reverse IOB Invoice #${response.createdIobInvoiceId}`);
  }
  if (response.warnings && response.warnings.length > 0) {
    parts.push(`Warnings: ${response.warnings.join(' | ')}`);
  }
  if (parts.length > 0) {
    ErrorMessage.SetNotification(parts.join('\n'));
  } else {
    ErrorMessage.SetNotification('Reverse IOB created.');
  }
}
